import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { RatingColors } from '../../../core/models/rating';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit {
  @Input() rating = 0;
  @Input() isClickable = true;
  @Output() ratingChange: EventEmitter<number> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (!this.isClickable) {
      this.getColor(this.rating);
    }
  }

  rate(index: number) {
    if (this.isClickable) {
      this.rating = index;
      this.ratingChange.emit(index);
    }
  }

  getColor(index: number) {
    if (index > this.rating) {
      return RatingColors.DEFAULT;
    } else {
      return RatingColors.ACTIVE;
    }
  }
}
